import { PhoneMeta } from "@/models/PhoneMeta";

export default function usePhone(errors: Map<string, string>): {
  sanitizePhoneNumber: (phoneNumber: string | null | undefined) => string | null;
  validatePhoneInput: (event: PhoneMeta) => void;
  validatePhoneHasValue: (phone: string | null | undefined) => void;
  // eslint-disable-next-line indent
} {
  
  const sanitizePhoneNumber = (phoneNumber: string | null | undefined) => {
    if (!phoneNumber) return null;
    return `+${phoneNumber.replace(/\D/g, "")}`;
  };

  const validatePhoneHasValue = (phone: string | null | undefined) => {
    const sanitizedPhone = sanitizePhoneNumber(phone ?? "");
    if (!sanitizedPhone || sanitizedPhone.length < 5) {
      errors.set("phone", "Invalid phone number.");
    } else {
      errors.delete("phone");
    }
  };

  const validatePhoneInput = (event: PhoneMeta) => {
    if (!event.valid && event.number) {
      errors.set("phone", "Invalid phone number.");
      return;
    } else {
      errors.delete("phone");
    }
  };

  return {
    sanitizePhoneNumber,
    validatePhoneInput,
    validatePhoneHasValue
  };
}
